// NPM Inports
import React, { useState, useRef, useEffect } from "react";
import { connect } from "react-redux";
// Component imports
import { ConfirmationBoxV2 } from "../../../commonComponents";
import TemplateTableRow from "./TemplateTableRow";

// Action imports
import {
  deleteTemplate,
  fetchAllDocumentTemplates,
} from "../../../actions/DocumentTemplateActions/templateActions";

// Internal Imports
import { AmplitudeUtils } from "../../../utils";
import { EVENTS } from "../../../constants";

// Destructuring
const { amplitudeLogEvent } = AmplitudeUtils;

function TemplateTableBody(props) {
  const templateTableBodyRef = useRef(null);
  const [showDeletePopup, _toggleDeletePopup] = useState(false);
  const [showDeleteItemBtnLoader] = useState(false);
  const [selectedTemplateId, setSeletedTemplateId] = useState(0);
  const [loadMore, setLoadMore] = useState(false);

  const _loadMoreTemplates = () => {
    if (
      templateTableBodyRef.current.scrollTop +
        templateTableBodyRef.current.clientHeight >=
      templateTableBodyRef.current.scrollHeight
    ) {
      // make api call
      const {
        fetchDocumentTemplates,
        pageNum,
        hasMore,
        showSearchPage,
      } = props;
      // Exclude search page
      if (!loadMore && hasMore && !showSearchPage) {
        setLoadMore(true);
        fetchDocumentTemplates(pageNum + 1, true)
          .then(() => {
            setLoadMore(false);
          })
          .catch(() => {
            setLoadMore(false);
          });
      }
    }
  };

  useEffect(
    () => {
      templateTableBodyRef.current.addEventListener(
        "scroll",
        _loadMoreTemplates,
      );
      return () => {
        templateTableBodyRef.current.removeEventListener(
          "scroll",
          _loadMoreTemplates,
        );
      };
    },
    [_loadMoreTemplates],
  );

  const { templates } = props;
  return (
    <div ref={templateTableBodyRef} className="templatedetails-table-wrapper ">
      {/* BODY SECTION */}
      <section>
        <div className="templatedetails-table-body">
          {templates &&
            templates.map(item => (
              <TemplateTableRow
                key={`${item.id}-template-list`}
                id={item.id}
                label={item.title}
                templateStatus={item.status}
                templateTag={item.template_tag}
                templateOwner={item.created_by.name || ""}
                profileUrl={item.created_by.image_url}
                lastModified={item.updated_at}
                toggleDeleteConfirmationPopup={() => {
                  _toggleDeletePopup(!showDeletePopup);
                }}
                setSeletedTemplateId={setSeletedTemplateId}
                templateUsergroups={item.usergroups}
              />
            ))}
        </div>
      </section>

      {/* CONFIRMATION POPUP SECTION */}
      <section>
        {showDeletePopup && (
          <ConfirmationBoxV2
            header="Are you sure you want to delete the selected item?"
            subHeader={`Once deleted, you won't be able to access.`}
            loaderMessage="Loading"
            showBtnLoader={showDeleteItemBtnLoader}
            closePopup={() => _toggleDeletePopup(false)}
            checkboxLabel="Yes, I want to delete."
            confirmAction={() =>
              props.deleteTemplate(selectedTemplateId).then(() => {
                _toggleDeletePopup(false);
                amplitudeLogEvent(EVENTS.EVENT_NAMES.TEMPLATE_DELETED, {
                  templateID: selectedTemplateId,
                });
              })
            }
            okBtnText="Delete"
          />
        )}
      </section>
    </div>
  );
}

const mapStateToProps = ({
  TemplateStore: {
    documentTemplatesInfo: { pageNum, hasMore },
  },
}) => ({
  pageNum,
  hasMore,
});

const mapDispatchToProps = {
  deleteTemplate,
  fetchDocumentTemplates: fetchAllDocumentTemplates,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(TemplateTableBody);



// WEBPACK FOOTER //
// ./src/components/TemplateV2/OrgTemplates/TemplateTableBody.js